export const styles = theme => ({
  player: {
    background: '#ce9568'
  },
  controls: {
    alignItems: 'center',
    display: 'flex',
    height: '7vh',
    justifyContent: 'space-evenly'
  },
  instructions: {
    fontSize: '12px',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    paddingLeft: '2px',
    paddingRight: '2px'
  },
  micDiv: {
    width: '45px ',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
    paddingTop: '3px'
  },
  arrow: {
    marginLeft: '2px',
    borderRadius: '50%',
    height: '47px',
    width: '30px'
  },
  mic: {
    borderRadius: '50%',
    height: '47px',
    width: '45px',
    margin: '-8px',
    '&:hover': {
      height: '49px',
      width: '47px'
    }
  },
  pauseDiv: {
    height: '100%',
    width: '45px ',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    paddingTop: '3px',
    '&hover': {
      background: 'grey'
    }
  },
  pauseButton: {
    borderRadius: '50%',
    height: '45px',
    width: '45px',
    margin: '-8px',
    '&:hover': {
      height: '47px',
      width: '47px'
    }
  }
});
